module.exports = __webpack_public_path__ + "img/voice-control.ed09fdb0.webp";